// The `<meta name="keywords">` of a built page: the pipe's Default Keywords
// (`PipeContentData.defaultKeywords`, General settings), rendered only where the
// distribution switches them on.
//
// The switch is the global boolean constant `isKeywordsEnabled`, off by default and
// overridden per distribution (Constant Overrides). A constant rather than a variable
// default because constants are baked into the release and set synchronously by
// `initialize`, so the tag is already in the prerendered HTML a crawler reads — a
// variable default seeds only after hydration. No row (an environment that never ran
// Seed Constants) or a non-boolean value means off.

/** A literal, not built from parts, so `yarn build:platform-keys` records the constant. */
export const IS_KEYWORDS_ENABLED_KEY = 'const.global.isKeywordsEnabled'

/**
 * The tag's `content`, or `undefined` to leave the tag out — unhead drops a meta whose
 * content is unset, and an empty keywords tag says nothing.
 *
 * `text` is the keywords translation as plain text, comma-separated. Each keyword is
 * trimmed, empty ones (`a,,b`, a trailing comma) are dropped, and a repeat is dropped
 * whatever its case, keeping the first spelling.
 */
export function resolveMetaKeywords(
  enabled: unknown,
  text: string | undefined,
): string | undefined {
  if (enabled !== true || !text) return undefined
  const seen = new Set<string>()
  const keywords: string[] = []
  for (const part of text.split(/[,\n]/)) {
    const keyword = part.trim().replace(/\s+/g, ' ')
    const folded = keyword.toLowerCase()
    if (!keyword || seen.has(folded)) continue
    seen.add(folded)
    keywords.push(keyword)
  }
  return keywords.length ? keywords.join(', ') : undefined
}
